module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-9ce38f7d67313588586b925beb683f17.png";